export const credits = {
  // Must be placed in the order it is desired they appear in the credits
  roles: {
    1: "Creator",
    2: "Technical Architect",
    3: "Lead Developer",
    4: "Android Developer",
    5: "Steam Developer",
    6: "Library Developer",
    7: "Developer",
    8: "Lead Design Consultant",
    9: "Design Consultant",
    10: "Modal Maker, Lady Taker, Pie Baker",
    11: "Lurker Tester",
    12: "Web Tester",
    13: "Android Tester"
  },

  // Each person must have a name and at least one role (the index of the desired role in roles). They can also have a
  // second name, which will appear in parentheses besides their first.
  people: [
    {
      name: "Hevipelle",
      name2: "Ivar Kerajärvi",
      roles: 1
    }, {
      name: "Razenpok",
      name2: "Andrei Andreev",
      roles: 2
    }, {
      name: "garnet420",
      roles: 3
    }, {
      name: "Omsi",
      roles: 3
    }, {
      name: "SpectralFlame",
      name2: "Christopher Yip",
      roles: 3
    }, {
      name: "WaitingIdly",
      roles: [3, 7, 9, 12, 13]
    }, {
      name: "kajfik",
      name2: "Jakub Kajfosz",
      roles: 4
    }, {
      name: "Makopaz",
      name2: "Zack Stein",
      roles: 5
    }, {
      name: "Patashu",
      roles: [6, 7, 12]
    }, {
      name: "Dan",
      roles: [7, 12]
    }, {
      name: "earth",
      name2: "Jace Royer",
      roles: [7, 10, 12, 13]
    }, {
      name: "Hira",
      roles: [7, 12, 13]
    }, {
      name: "IkerStream",
      name2: "Iker de Aguirre",
      roles: [7, 12]
    }, {
      name: "L4R5",
      name2: "Lars Wolf",
      roles: [7, 12, 13]
    }, {
      name: "Pichusuperlover",
      roles: [7, 9, 12]
    }, {
      name: "realrapidjazz",
      roles: [7, 8]
    }, {
      name: "Scarlet",
      roles: [7, 12, 13]
    }, {
      name: "slabdrill",
      roles: 7
    }, {
      name: "Acamaeda",
      roles: [9, 12]
    }, {
      name: "Dravitar",
      name2: "Alex Henderson",
      roles: 11
    }, {
      name: "Aesis",
      roles: 12
    }, {
      name: "AFYINEE",
      name2: "Gabriel HADDAG",
      roles: 12
    }, {
      name: "Alexitato",
      roles: 12
    }, {
      name: "Anno",
      roles: 12
    }, {
      name: "Archa",
      name2: "Myresa",
      roles: [12, 13]
    }, {
      name: "ArrowBounce",
      name2: "Timothy Su",
      roles: 12
    }, {
      name: "Birb",
      name2: "Kelsey Black",
      roles: 12
    }, {
      name: "Boo",
      name2: "Jean-Christophe Bourgault",
      roles: 12
    }, {
      name: "CaptainGalaxy",
      name2: "Ovidijus Točelis",
      roles: 12
    }, {
      name: "ChaoticHans",
      roles: [12, 13]
    }, {
      name: "cubic frog",
      roles: 12
    }, {
      name: "dankesehr",
      roles: 12
    }, {
      name: "Davixx",
      name2: "Davide Fedele",
      roles: 12
    }, {
      name: "Empireus",
      roles: 12
    }, {
      name: "GirixK",
      name2: "Nikola Jelinčić",
      roles: [12, 13]
    }, {
      name: "GoldenTritium",
      roles: [12, 13]
    }, {
      name: "Kael",
      roles: 12
    }, {
      name: "Lynn",
      roles: 12
    }, {
      name: "Merp",
      roles: 12
    }, {
      name: "philipebreaker",
      name2: "Philipe",
      roles: 12
    }, {
      name: "Phillip Marshall",
      roles: 12
    }, {
      name: "Phoenix",
      roles: 12
    }, {
      name: "Reda Kotob",
      roles: 12
    }, {
      name: "Saturnus",
      roles: 12
    }, {
      name: "SereKabii",
      roles: 12
    }, {
      name: "Sheer",
      roles: 12
    }, {
      name: "sirusi",
      name2: "Vinícius Oliveira Martins",
      roles: 12
    }, {
      name: "Spanosa",
      name2: "Jared K",
      roles: 12
    }, {
      name: "Sparticle999",
      roles: 12
    }, {
      name: "SpicyCrusader13",
      roles: [12, 13]
    }, {
      name: "Storm",
      roles: 12
    }, {
      name: "SzyszakS",
      roles: 12
    }, {
      name: "Tacitus",
      roles: 12
    }, {
      name: "Typh",
      roles: 12
    }, {
      name: "Vnge",
      name2: "Ben Parrish",
      roles: [12, 13]
    }, {
      name: "Xemadus",
      name2: "Jonathan Gibson",
      roles: 12
    }, {
      name: "Young Woo Joo",
      roles: 12
    }, {
      name: "Zipi",
      roles: 12
    }, {
      name: "about:blank",
      roles: 13
    }, {
      name: "ÆiOuF",
      roles: 13
    }, {
      name: "Akirious",
      roles: 13
    }, {
      name: "Anjinho01",
      roles: 13
    }, {
      name: "Anthios",
      roles: 13
    }, {
      name: "Aubrey Ark",
      roles: 13
    }, {
      name: "Auti",
      name2: "Lucia Tolle",
      roles: 13
    }, {
      name: "Buck",
      roles: 13
    }, {
      name: "Barrin84",
      roles: 13
    }, {
      name: "Calmcat",
      roles: 13
    }, {
      name: "ChizuX",
      roles: 13
    }, {
      name: "Circle",
      roles: 13
    }, {
      name: "Crinkly Weasel",
      name2: "Aaryan Sarawgi",
      roles: 13
    }, {
      name: "Daniella",
      roles: 13
    }, {
      name: "DarthDie",
      name2: "Briar Bowser",
      roles: 13
    }, {
      name: "ElPopote83",
      roles: 13
    }, {
      name: "Epsilon",
      name2: "Coolguystorm",
      roles: 13
    }, {
      name: "Firecracker",
      roles: 13
    }, {
      name: "Gaunter",
      roles: 13
    }, {
      name: "Gimmick",
      roles: 13
    }, {
      name: "HarrisL2",
      roles: 13
    }, {
      name: "Hellbach",
      name2: "Asher Günther",
      roles: 13
    }, {
      name: "hen-ben",
      name2: "Henry Ellenberg",
      roles: 13
    }, {
      name: "ImpossibleSalsa",
      roles: 13
    }, {
      name: "JayM#1872",
      name2: "Jay McGee",
      roles: 13
    }, {
      name: "Johanniklas",
      name2: "Jan-Niklas Petersen",
      roles: 13
    }, {
      name: "Joseph Micheli",
      roles: 13
    }, {
      name: "kaislash",
      name2: "Lily",
      roles: 13
    }, {
      name: "Kirku",
      name2: "Fabian Makowski",
      roles: 13
    }, {
      name: "Kirin",
      name2: "Arthur",
      roles: 13
    }, {
      name: "Klötzchen",
      roles: 13
    }, {
      name: "L5racer",
      roles: 13
    }, {
      name: "Marshmallow",
      roles: 13
    }, {
      name: "HyperionMike",
      name2: "Miikael Siitan",
      roles: 13
    }, {
      name: "Mirai",
      roles: 13
    }, {
      name: "Monoma",
      name2: "ARoman Ruiz",
      roles: 13
    }, {
      name: "Nani",
      roles: 13
    }, {
      name: "Neo",
      name2: "Joon",
      roles: 13
    }, {
      name: "netweak",
      roles: 13
    }, {
      name: "NiZeKiHo",
      name2: "DominusDane",
      roles: 13
    }, {
      name: "NotBrewst",
      name2: "Luc Leblanc",
      roles: 13
    }, {
      name: "opdollar",
      name2: "Zane Coole",
      roles: 13
    }, {
      name: "Pavlxiiv",
      roles: 13
    }, {
      name: "PotatoTIAB",
      roles: 13
    }, {
      name: "Razor",
      roles: 13
    }, {
      name: "Razvan Cercel",
      roles: 13
    }, {
      name: "ReacTivity",
      roles: 13
    }, {
      name: "Reaxt",
      name2: "Rea Koehler",
      roles: 13
    }, {
      name: "Ruins",
      roles: 13
    }, {
      name: "Rukimix",
      roles: 13
    }, {
      name: "shadowevil",
      roles: 13
    }, {
      name: "Skunky",
      name2: "Lukas",
      roles: 13
    }, {
      name: "Snaeky",
      roles: 13
    }, {
      name: "Socks",
      name2: "Hannah Pocks",
      roles: 13
    }, {
      name: "Sweets the Alien",
      roles: 13
    }, {
      name: "Tables",
      roles: 13,
    }, {
      name: "Taylor Reeves",
      roles: 13
    }, {
      name: "TheAhmex",
      roles: 13
    }, {
      name: "The Trust Melon",
      roles: 13
    }, {
      name: "Tim Wong",
      roles: 13
    }, {
      name: "tragedt",
      name2: "Ethan Manninen",
      roles: 13
    }, {
      name: "tui sapo",
      roles: 13
    }, {
      name: "Valentine Clarissa Alanis Star Z",
      roles: 13
    }, {
      name: "vanadium_void",
      roles: 13
    }, {
      name: "X3N0_32",
      roles: 13
    }, {
      name: "ZylaKat",
      name2: "Katherine Goforth-Harbin",
      roles: 13
    }
  ]
};

credits.roles.count = Object.keys(credits.roles).length;
